import { Switch as S } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/** Liga/desliga. O estado ligado usa o grafite claro, não o acento (reservado ao "agora"). */
export function Switch({ className, ...props }: ComponentProps<typeof S.Root>) {
  return (
    <S.Root
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full bg-press transition-colors outline-none focus-visible:ring-2 focus-visible:ring-info disabled:opacity-45 data-[state=checked]:bg-fg-muted',
        className,
      )}
      {...props}
    >
      <S.Thumb className="block size-4 translate-x-0.5 rounded-full bg-fg shadow transition-transform duration-150 data-[state=checked]:translate-x-[18px] data-[state=checked]:bg-stage" />
    </S.Root>
  );
}
